import AICampusFooter from "@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue";
import NavigationBackButton from '@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue';
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from '@/utils/mixins/formatting_mixins';
import axios from 'axios';
import {
  LIST_ENTITY_ASSESSMENTS,
  SUBMIT_ASSESSMENT_ANSWERS,
  GET_SUBMITTED_ANSWERS
} from '@/utils/constants/constants.js';

export default {
  name: 'EntityRiskAssessment',
  mixins: [alert_mixin, formatting_mixins],
  components: { AICampusFooter, NavigationBackButton },

  data: () => ({
    assessments: [],
    active_assessment: null,
    answers: {},
    entity_id: null,
    result: null,
    submitting: false,
  }),

  async mounted() {
    this.entity_id = sessionStorage.getItem('entity_id');
    if (!this.entity_id) {
      this.show_error('Entity ID not found in session storage.');
      return;
    }
    this.fetch_and_load();
  },

  methods: {
    async fetch_and_load() {
      const entity_type_id = sessionStorage.getItem('entity_type_id');
      if (!entity_type_id) return;
      const { data: body } = await axios.get(LIST_ENTITY_ASSESSMENTS, { params: { entity_type_id } });
      if (body.status === 'success') {
        this.assessments = [...body.pre_assessments, ...body.post_assessments];
        this.select_assessment(this.assessments[0]?.id || null);
      }
    },

    init_answers() {
      this.assessments
        .filter(a => a.id === this.active_assessment)
        .flatMap(a => a.questions)
        .forEach(q => {
          this.answers[q.id] = q.type === 'multi_select' ? [] : '';
        });
      this.result = null;
    },

    select_assessment(id) {
      this.active_assessment = id;
      this.init_answers();
      if (id) {
        this.load_submitted(id);
      }
    },

    left_questions(questions) {
      return questions.slice(0, Math.ceil(questions.length / 2));
    },
    right_questions(questions) {
      return questions.slice(Math.ceil(questions.length / 2));
    },

    async load_submitted(assessment_id) {
      axios.get(GET_SUBMITTED_ANSWERS, {
        params: { entity_id: this.entity_id, assessment_id }
      })
      .then(({ data }) => {
        if (data.status === 'success') {
          Object.entries(data.data.answers).forEach(([qid, val]) => {
            this.answers[Number(qid)] = val;
          });
          this.result = {
            total_score: data.data.total_score,
            risk_level: data.data.risk_level,
            auto_decision: data.data.auto_decision
          };
        }
      })
      .catch(error => console.error('Error occurred:', error));
    },

    async submit_answers() {
      if (!this.entity_id || !this.active_assessment) return;
      this.submitting = true;
      try {
        const { data } = await axios.post(SUBMIT_ASSESSMENT_ANSWERS, {
          entity_id: this.entity_id,
          assessment_id: this.active_assessment,
          answers: this.answers
        });
        if (data.status === 'success') {
          Object.entries(data.data.answers).forEach(([qid, val]) => {
            this.answers[Number(qid)] = val;
          });
          this.result = {
            total_score: data.data.total_score,
            risk_level: data.data.risk_level,
            auto_decision: data.data.auto_decision
          };
        } else {
          this.show_error('submit', data.message);
        }
      } finally {
        this.submitting = false;
      }
    }
  }
};